export default {
  isochrones: {
    isochrones: 'Isochronen',
    isochronesReady: 'Isochronen fertig',
    calculatingIsochrones: 'Berechne Isochronen…',
    itWasNotPossibleToCalculateIsochronesWithTheDefinedOptions: 'Berechnung mit diesen Einstellungen nicht möglich. Versuche kleinere Isochronen oder größere Intervalle.',
    couldResolveTheSelectedPlaceAsASuitableCenter: 'Der gewählte Ort konnte nicht als Zentrum genutzt werden.',
    apiError: {
      2003: 'Die Fläche der zu vermeidenden Polygone darf 20.000 Quadratkilometer nicht überschreiten.',
      3001: 'Mindestens ein Parameter hat einen fehlerhaften Wert oder ein falsches Format.',
      3004: 'Die gewählte Kombination zwischen Fahrzeugprofil, Intervall und Zeit/Distance überschreitet die Grenzwerte der öffentliche ORS Instanz. Bitte passen Sie die Werte an.',
      3099: 'Es war nicht möglich Isochronen für die gewählten Punkte mit diesem Fahrzeugprofil zu berechnen.',
      3003: 'Der Parameter "avoid features" hat den falschen Wert "null".'
    },
    genericErrorMsg: 'Es war nicht möglich, Isochronen zu berechnen.',
    timeoutError: 'Die Anfrage dauerte zu lange und wurde abgebrochen. Versuchen Sie kleinere Reichweiten und Intervalle.'
  }
}
